import moment from 'moment';
import i18n from '../../services/i18n.js';


let landscapeForms = [];

const MAX_NIGHTS = process.env.REACT_APP_SEARCH_MAX_NIGHTS;

export const registerLandScapeForm = (form) => {
    //if (!landscapeForms) {
    landscapeForms.push(form);
    //} else {
    //   throw new Error('Landscape form already registered');
    //}
};

export const updateLandScapeForm = (action, data) => {
    landscapeForms.map(form => {
        if (form && form.handleUpdate) {
            form.handleUpdate(action, data);
        }
    });
};

/**
 * Funcion que devuelve un objecto jsoneable de los filtros de backend aplicados.
 * Hay que hacer un especial tratamiento para el filtro de:
 * - onrequest
 * - hotelName
 * - prices
 * 
 * @param {Object} HistoGramfilters 
 */
export const getBackendFilters = (filters) => {
    const appliedFilters = getCheckedAppliedFilters(filters);
    delete appliedFilters.total;
    Object.keys(filters).map(key => {
        if (filters[key] !== undefined && Array.isArray(filters[key])) {
            appliedFilters[key] = filters[key].filter(fi => fi.checked).map(fi => fi.code);
            if (appliedFilters[key].length < 1) {
                delete appliedFilters[key];
            }
        }
    });
    return appliedFilters;
    /*return {
        prices: appliedFilters.pricesApplied.map(p => ({ min: p.min, max: p.max })),
        onrequest: filters ? filters.onrequest : false,
        hotelName: filters ? filters.hotelName : ''
    };*/
};
/**
 * Devuelve un object con el total de filtros aplicados (checked)
 * 
 * @param {Object} histogramFilter object
 */
export const getCheckedAppliedFilters = (filters) => {
    let filterAppliedObject = {};
    filterAppliedObject.total = 0;
    Object.keys(filters).map(key => {
        if (filters[key] !== undefined && Array.isArray(filters[key])) {
            filterAppliedObject[key] = filters[key].filter(o => o.checked);
            if (filterAppliedObject[key].length > 0) {
                filterAppliedObject.total += filterAppliedObject[key].length;
            } else {
                delete filterAppliedObject[key];
            }
        }
    });
    return filterAppliedObject;
};

/*
    * El histograma debe tener los siguientes Array (expectedKeys) properties para funcionar.
    * A su vez dentro de ese array debe tener los objectos de negocio HistoFilters();
    *       "filterName": [
    *           {
    *             "type": "onrequest",
    *             "jsonpath": "@onrequest",
    *             "value": true,
    *             "code": true,
    *             "label": "On Request",
    *             "description": "On Request",
    *             "checked": false,
    *             "count": 0
    *          }
    *      ],
    */
export const validateHistogramFilters = (histogramResult) => {
    let expectedKeys = ['mealPlans', 'offers', 'priceRanges', 'onrequest', 'hotelName', 'categories', 'towns', 'facilities', 'accomodations', 'recommendedHotels', 'favoritesHotels','available', 'cardPrepaid'];
    if (!histogramResult) {
        histogramResult = {};
    }
    expectedKeys.forEach(key => {
        if (!histogramResult[key]) {
            histogramResult[key] = [];
        }
    });
    return histogramResult;
};

/**
 * Auxiliar function used by SearchContent.js and ModifyDatesView.js to update
 * state after checkIn/checkIn date controls change its value
 * @param {Object} component the component caller
 * @param {String} date the value to update
 */
export const handlecheckInChangeFactory = function (component) {
    return (date) => {
        let nights = component.state.nights;
        let checkOut = moment(date)
            .clone()
            .add(nights, 'days');
        component.setState((prevState, props) => ({
            checkIn: date,
            checkOut: checkOut
        }));
    };
};

/**
 * Auxiliar function used by SearchContent.js and ModifyDatesView.js to update
 * state after checkOut/checkOut date controls change its value
 * @param {Object} component the component caller
 * @param {String} date the value to update
 * @return {Integer} amount of nights between checkIn and checkOut
 */
export const handlecheckOutChangeFactory = function (component) {
    return (date) => {
        let diff = moment(date).startOf('day').diff(moment(component.state.checkIn).startOf('day'), 'days');
        if (diff < 1) {
            alert(i18n.t('ALERT.DATE_RANGE_WRONG'));
        }
        diff = diff < 1 ? 1 : diff;
        if (diff > MAX_NIGHTS) {
            alert(i18n.t('ALERT.NIGTH_RANGE_EXCEED', { max: MAX_NIGHTS }));
            diff = MAX_NIGHTS;
            date = moment(component.state.checkIn).add(diff, 'days');
        }
        component.setState((prevState, props) => ({
            checkOut: date,
            nights: diff
        }));
        return diff;
    };
};

/**
 * Auxiliar function used by SearchContent.js and ModifyDatesView.js to update
 * state after amount of nights control change its value
 * @param {Object} component the component caller
 * @param {Integer} amount amount of nights between checkIn and checkOut
 */
export const handleNightsChangeFactory = function (component) {
    return (amount) => {
        let val = Number.parseInt(amount.target.value);
        if (isNaN(val)) {
            component.setState({
                nights: ''
            });
            return;
        }
        val = val < 1 ? 1 : Math.min(val, MAX_NIGHTS);
        component.prevNigths = val;
        let checkOut = moment(component.state.checkIn)
            .clone()
            .add(val, 'days');
        component.setState({
            checkOut: checkOut,
            nights: val
        });
    };
};

export const handleNightsEnterFactory = function (e, component) {
    if (e.keyCode == 13 || e.type == 'blur') {
        let val = Number.parseInt(e.target.value);
        if (isNaN(val)) {
            component.setState({
                nights: component.prevNigths
            });
            return;
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/Utils/FilterChangeFunctions.js